<template>
    <div class="filter-bar">
        <form>
            <div class="form-group w-full">
                <div class="form-control-wrapper _search">
                    <input type="text" v-model="filterText" @input="isTyping = true" class="form-control bg-white" autocomplete="off" :placeholder="placeholderString" @keydown.enter.prevent="filterData">
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import { debounce } from 'lodash'

export default {
    props: {
        placeholder: {
            type: String,
            default: '',
        },
    },

    data () {
        return {
            filterText: '',
            minLength: 3,
            isTyping: false,
            // Time in ms after user stops typing to trigger method call
            // debounce: 250,
        }
    },

    computed: {
        isFilterable () {
            return this.filterText !== '' && this.filterText.length >= 3
        },

        placeholderString () {
            return this.placeholder.length > 0 ? this.placeholder : 'Pretraga'
        },
    },

    watch: {
        filterText: _.debounce(function () {
            this.isTyping = false
        }, 250),

        isTyping: function (status) {
            if (!status) {
                this.filterData()
            }
        }
    },

    methods: {
        filterData() {
            if (this.isFilterable) {
                Bus.$emit('filterSet', this.filterText)
            } else if (this.filterText == '') {
                this.resetFilter()
            }
        },

        resetFilter() {
            this.filterText = ''

            Bus.$emit('filterReset')
        }
    }
}
</script>
